import { getListCodeCountry } from '../api/getListCodeCountry';
import { setGetListCodeCountryAction } from '../action';

export const setGetListCodeCountry = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListCodeCountry(params);
            dispatch(setGetListCodeCountryAction(data.data));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}